export default __webpack_public_path__ + "static/media/genesys-dialer.26034a9e.jpg";